import { render, staticRenderFns } from "./contractDetailHisRoomFee.vue?vue&type=template&id=899d4a94&scoped=true"
import script from "./contractDetailHisRoomFee.vue?vue&type=script&lang=js"
export * from "./contractDetailHisRoomFee.vue?vue&type=script&lang=js"
import style0 from "./contractDetailHisRoomFee.vue?vue&type=style&index=0&id=899d4a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899d4a94",
  null
  
)

export default component.exports